/**
 * LyteWork Trophy Plates Customizer V3
 * Clean, mobile-first, modal-based bulk ordering
 * Matches Universal Customizer branding
 */

(function() {
    'use strict';
    
    console.log('%c✅ Trophy Plates Customizer V3 LOADED', 'background: #233354; color: #d6c390; padding: 5px; font-size: 12px;');

    // ========== STATE ==========
    const state = {
        plates: [{ line1: '', line2: '', line3: '' }],
        currentPreview: 0,
        repeatLine2: false,
        repeatLine3: false,
        productTitle: '',
        variantTitle: '',
        basePrice: 0,
        currentPrice: 0,
        variantId: null
    };

    let modal = null;
    let scrollY = 0;

    // ========== INITIALIZATION ==========
    function init() {
        // Check for quote data in URL
        loadQuoteFromUrl();
        
        // The trigger button is rendered by the Liquid snippet
        // Just ensure the hidden field exists
        const wrapper = document.querySelector('.tp-trigger-wrapper');
        if (wrapper && !document.getElementById('tp-plates-data')) {
            const hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = 'properties[_plates_data]';
            hidden.id = 'tp-plates-data';
            wrapper.appendChild(hidden);
        }
    }

    // ========== MODAL ==========
    function open() {
        if (modal) {
            // Modal exists - sync with page quantity before showing
            syncQuantityFromPage();
            modal.classList.add('active');
            lockBodyScroll();
            return;
        }
        
        loadProductData();
        syncQuantityFromPage();
        buildModal();
        lockBodyScroll();
        requestAnimationFrame(() => modal.classList.add('active'));
    }
    
    function syncQuantityFromPage() {
        // Read quantity from page input or checked radio button
        let targetQty = 1;
        
        // First check if a quantity break radio is selected
        const checkedRadio = document.querySelector('input[name="product-qty-breaks"]:checked');
        if (checkedRadio && checkedRadio.dataset.qty) {
            targetQty = parseInt(checkedRadio.dataset.qty) || 1;
        } else {
            // Fall back to quantity input
            const qtyInput = document.querySelector('input[name="quantity"]');
            if (qtyInput) {
                targetQty = parseInt(qtyInput.value) || 1;
            }
        }
        
        // Adjust plates array to match target quantity
        const currentQty = state.plates.length;
        
        if (targetQty > currentQty) {
            // Add more plates
            for (let i = currentQty; i < targetQty; i++) {
                state.plates.push({
                    line1: '',
                    line2: state.repeatLine2 ? state.plates[0]?.line2 || '' : '',
                    line3: state.repeatLine3 ? state.plates[0]?.line3 || '' : ''
                });
            }
        } else if (targetQty < currentQty) {
            // Remove plates from the end
            state.plates.splice(targetQty);
        }
        
        // Reset preview to first plate if needed
        if (state.currentPreview >= state.plates.length) {
            state.currentPreview = 0;
        }
        
        // Re-render if modal exists
        if (modal) {
            renderPlates();
            updateNavButtons();
            updatePrice();
        }
    }

    function close() {
        if (modal) {
            modal.classList.remove('active');
            unlockBodyScroll();
        }
    }

    function lockBodyScroll() {
        scrollY = window.scrollY;
        document.body.classList.add('tp-modal-open');
        document.documentElement.classList.add('tp-modal-open');
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.overflow = 'hidden';
    }

    function unlockBodyScroll() {
        document.body.classList.remove('tp-modal-open');
        document.documentElement.classList.remove('tp-modal-open');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.overflow = '';
        window.scrollTo(0, scrollY);
    }

    function loadProductData() {
        try {
            // Get product title
            const titleEl = document.querySelector('.product__title h1, .product-single__title, h1.product-title');
            if (titleEl) state.productTitle = titleEl.textContent.trim();

            // Get variant info from Shopify
            if (window.ShopifyAnalytics?.meta?.product) {
                const product = window.ShopifyAnalytics.meta.product;
                state.productTitle = product.title || state.productTitle;
                
                // Get selected variant
                const variantId = new URLSearchParams(window.location.search).get('variant') ||
                    document.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
                
                if (variantId) {
                    const variant = product.variants.find(v => v.id == variantId);
                    if (variant) {
                        state.variantTitle = variant.title !== 'Default Title' ? variant.title : '';
                        state.basePrice = variant.price / 100;
                        state.variantId = variant.id;
                    }
                } else if (product.variants[0]) {
                    state.basePrice = product.variants[0].price / 100;
                }
            }
        } catch (e) {
            console.warn('Could not load product data:', e);
        }
    }

    function buildModal() {
        const html = `
            <div id="tp-modal" class="tp-modal">
                <div class="tp-overlay" onclick="window.trophyPlates.close()"></div>
                <div class="tp-container">
                    <div class="tp-header">
                        <div class="tp-header-left">
                            <img src="https://cdn.shopify.com/s/files/1/0590/2244/2570/files/Color_Update_-_2025_-_website.png?v=1764288940" alt="LyteWork" class="tp-logo">
                            <div>
                                <h2>Trophy Plate Customizer</h2>
                                <p>${state.variantTitle || state.productTitle || 'Customize Your Plates'}</p>
                            </div>
                        </div>
                        <button class="tp-close-btn" onclick="window.trophyPlates.close()">&times;</button>
                    </div>
                    
                    <div class="tp-body">
                        <div class="tp-preview-section">
                            <div class="tp-preview-nav">
                                <button class="tp-nav-btn" id="tp-prev-btn" onclick="window.trophyPlates.prevPlate()">‹</button>
                                <div class="tp-preview-indicator">
                                    Plate <span id="tp-current-num">1</span> of <span id="tp-total-num">1</span>
                                </div>
                                <button class="tp-nav-btn" id="tp-next-btn" onclick="window.trophyPlates.nextPlate()">›</button>
                            </div>
                            <div class="tp-plate-preview">
                                <div class="tp-preview-line" id="tp-preview-1">John Smith</div>
                                <div class="tp-preview-line" id="tp-preview-2">Most Valuable Player</div>
                                <div class="tp-preview-line" id="tp-preview-3">2025 Season</div>
                            </div>
                        </div>
                        
                        <div class="tp-table-section">
                            <div class="tp-repeat-section">
                                <div class="tp-repeat-title">Repeat on all plates:</div>
                                <div class="tp-repeat-options">
                                    <label class="tp-checkbox-group">
                                        <input type="checkbox" id="tp-repeat-2" onchange="window.trophyPlates.toggleRepeat(2)">
                                        <span>Line 2 (e.g., Team Name)</span>
                                    </label>
                                    <label class="tp-checkbox-group">
                                        <input type="checkbox" id="tp-repeat-3" onchange="window.trophyPlates.toggleRepeat(3)">
                                        <span>Line 3 (e.g., Year)</span>
                                    </label>
                                </div>
                            </div>
                            
                            <div class="tp-plates-list" id="tp-plates-list">
                                <!-- Plates render here -->
                            </div>
                        </div>
                    </div>
                    
                    <div class="tp-footer">
                        <div class="tp-footer-left">
                            <div class="tp-price-display">
                                <span class="tp-total-price" id="tp-total-price">$0.00</span>
                                <span class="tp-each-price" id="tp-each-price">($0.00/ea)</span>
                            </div>
                        </div>
                        <div class="tp-footer-center">
                            <div class="tp-quantity-display" id="tp-quantity">1</div>
                            <div class="tp-quantity-label">Plates</div>
                        </div>
                        <div class="tp-footer-right">
                            <button class="tp-btn tp-btn-secondary" onclick="window.trophyPlates.addPlate()">+ Add Plate</button>
                            <button class="tp-btn tp-btn-primary" onclick="window.trophyPlates.addToCart()">Add to Cart</button>
                        </div>
                    </div>
                </div>
            </div>
        `;
        
        document.body.insertAdjacentHTML('beforeend', html);
        modal = document.getElementById('tp-modal');
        
        renderPlates();
        updateNavButtons();
        updatePrice();
    }

    // ========== PLATE MANAGEMENT ==========
    function renderPlates() {
        const container = document.getElementById('tp-plates-list');
        if (!container) return;
        
        container.innerHTML = state.plates.map((plate, index) => `
            <div class="tp-plate-card ${index === state.currentPreview ? 'active' : ''}" data-index="${index}">
                <div class="tp-card-header">
                    <span class="tp-plate-number">Plate ${index + 1}</span>
                    ${state.plates.length > 1 ? `
                        <button class="tp-remove-btn" onclick="window.trophyPlates.removePlate(${index})" title="Remove plate">×</button>
                    ` : ''}
                </div>
                <div class="tp-card-inputs">
                    <div class="tp-input-group">
                        <label>Line 1 (Name/Title)</label>
                        <input type="text" 
                            class="tp-input" 
                            placeholder="e.g., John Smith"
                            value="${escapeHtml(plate.line1)}"
                            data-plate="${index}" 
                            data-line="1"
                            onfocus="window.trophyPlates.setPreview(${index})"
                            oninput="window.trophyPlates.updatePlate(${index}, 1, this.value)">
                    </div>
                    <div class="tp-input-group">
                        <label>Line 2 (Team/Award)</label>
                        <input type="text" 
                            class="tp-input" 
                            placeholder="e.g., Most Valuable Player"
                            value="${escapeHtml(plate.line2)}"
                            data-plate="${index}" 
                            data-line="2"
                            ${state.repeatLine2 && index > 0 ? 'readonly' : ''}
                            onfocus="window.trophyPlates.setPreview(${index})"
                            oninput="window.trophyPlates.updatePlate(${index}, 2, this.value)">
                    </div>
                    <div class="tp-input-group">
                        <label>Line 3 (Year/Date)</label>
                        <input type="text" 
                            class="tp-input" 
                            placeholder="e.g., 2025 Season"
                            value="${escapeHtml(plate.line3)}"
                            data-plate="${index}" 
                            data-line="3"
                            ${state.repeatLine3 && index > 0 ? 'readonly' : ''}
                            onfocus="window.trophyPlates.setPreview(${index})"
                            oninput="window.trophyPlates.updatePlate(${index}, 3, this.value)">
                    </div>
                </div>
            </div>
        `).join('');
        
        updateQuantityDisplay();
        updatePreview();
    }

    function addPlate() {
        const newPlate = {
            line1: '',
            line2: state.repeatLine2 ? state.plates[0].line2 : '',
            line3: state.repeatLine3 ? state.plates[0].line3 : ''
        };
        state.plates.push(newPlate);
        state.currentPreview = state.plates.length - 1;
        
        renderPlates();
        updateNavButtons();
        
        // Scroll to new plate and focus
        setTimeout(() => {
            const cards = document.querySelectorAll('.tp-plate-card');
            const lastCard = cards[cards.length - 1];
            if (lastCard) {
                lastCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
                const firstInput = lastCard.querySelector('.tp-input');
                if (firstInput) firstInput.focus();
            }
        }, 100);
    }

    function removePlate(index) {
        if (state.plates.length <= 1) return;
        
        state.plates.splice(index, 1);
        
        // Adjust preview index if needed
        if (state.currentPreview >= state.plates.length) {
            state.currentPreview = state.plates.length - 1;
        } else if (state.currentPreview > index) {
            state.currentPreview--;
        }
        
        renderPlates();
        updateNavButtons();
    }

    function updatePlate(plateIndex, lineNum, value) {
        state.plates[plateIndex][`line${lineNum}`] = value;
        
        // Handle repeat logic
        if (plateIndex === 0) {
            if (lineNum === 2 && state.repeatLine2) {
                state.plates.forEach((p, i) => {
                    if (i > 0) p.line2 = value;
                });
                renderPlates();
            }
            if (lineNum === 3 && state.repeatLine3) {
                state.plates.forEach((p, i) => {
                    if (i > 0) p.line3 = value;
                });
                renderPlates();
            }
        }
        
        // Update preview if this is the current plate
        if (plateIndex === state.currentPreview) {
            updatePreview();
        }
        
        saveToHiddenField();
    }

    // ========== PREVIEW ==========
    function setPreview(index) {
        if (index < 0 || index >= state.plates.length) return;
        state.currentPreview = index;
        
        // Update active card styling
        document.querySelectorAll('.tp-plate-card').forEach((card, i) => {
            card.classList.toggle('active', i === index);
        });
        
        updatePreview();
        updateNavButtons();
    }

    function updatePreview() {
        const plate = state.plates[state.currentPreview];
        if (!plate) return;
        
        document.getElementById('tp-preview-1').textContent = plate.line1 || 'John Smith';
        document.getElementById('tp-preview-2').textContent = plate.line2 || 'Most Valuable Player';
        document.getElementById('tp-preview-3').textContent = plate.line3 || '2025 Season';
        document.getElementById('tp-current-num').textContent = state.currentPreview + 1;
        document.getElementById('tp-total-num').textContent = state.plates.length;
    }

    function prevPlate() {
        if (state.currentPreview > 0) {
            setPreview(state.currentPreview - 1);
            scrollToPlate(state.currentPreview);
        }
    }

    function nextPlate() {
        if (state.currentPreview < state.plates.length - 1) {
            setPreview(state.currentPreview + 1);
            scrollToPlate(state.currentPreview);
        }
    }

    function scrollToPlate(index) {
        const cards = document.querySelectorAll('.tp-plate-card');
        if (cards[index]) {
            cards[index].scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    function updateNavButtons() {
        const prevBtn = document.getElementById('tp-prev-btn');
        const nextBtn = document.getElementById('tp-next-btn');
        
        if (prevBtn) prevBtn.disabled = state.currentPreview === 0;
        if (nextBtn) nextBtn.disabled = state.currentPreview >= state.plates.length - 1;
    }

    // ========== REPEAT FUNCTIONALITY ==========
    function toggleRepeat(lineNum) {
        const checkbox = document.getElementById(`tp-repeat-${lineNum}`);
        const isChecked = checkbox?.checked || false;
        
        if (lineNum === 2) {
            state.repeatLine2 = isChecked;
            if (isChecked) {
                const masterValue = state.plates[0].line2;
                state.plates.forEach((p, i) => {
                    if (i > 0) p.line2 = masterValue;
                });
            }
        } else if (lineNum === 3) {
            state.repeatLine3 = isChecked;
            if (isChecked) {
                const masterValue = state.plates[0].line3;
                state.plates.forEach((p, i) => {
                    if (i > 0) p.line3 = masterValue;
                });
            }
        }
        
        renderPlates();
        
        // Restore checkbox state after re-render
        if (checkbox) checkbox.checked = isChecked;
    }

    // ========== QUANTITY & PRICING ==========
    function updateQuantityDisplay() {
        const count = state.plates.length;
        const qtyEl = document.getElementById('tp-quantity');
        if (qtyEl) qtyEl.textContent = count;
        
        // Update Shopify quantity and radio buttons
        updateShopifyQuantity(count);
        
        // Update pricing
        updatePrice();
    }

    function updateShopifyQuantity(qty) {
        const qtyInput = document.querySelector('input[name="quantity"]');
        if (qtyInput) {
            qtyInput.value = qty;
            qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    function updatePrice() {
        const quantity = state.plates.length;
        let unitPrice = state.basePrice;
        
        // Check for quantity break radio buttons (same pattern as universal customizer)
        const radios = document.querySelectorAll('input[name="product-qty-breaks"]');
        let bestTier = null;
        
        radios.forEach(r => {
            const tierQty = parseInt(r.dataset.qty);
            if (tierQty <= quantity && (!bestTier || tierQty > bestTier.qty)) {
                bestTier = { qty: tierQty, el: r };
            }
        });
        
        if (bestTier) {
            // Check the appropriate radio button
            if (!bestTier.el.checked) bestTier.el.checked = true;
            
            // Get the discounted price from the radio button
            const rawPrice = bestTier.el.dataset.totalPrice;
            if (rawPrice) {
                unitPrice = parseFloat(rawPrice.replace(/[^0-9.]/g, '')) / bestTier.qty;
            }
        } else {
            // Uncheck all if no tier matches
            radios.forEach(r => r.checked = false);
        }
        
        state.currentPrice = unitPrice;
        const total = unitPrice * quantity;
        
        // Update the display
        const totalEl = document.getElementById('tp-total-price');
        const eachEl = document.getElementById('tp-each-price');
        
        if (totalEl) totalEl.textContent = '$' + total.toFixed(2);
        if (eachEl) eachEl.textContent = '($' + unitPrice.toFixed(2) + '/ea)';
    }

    // ========== CART ==========
    function addToCart() {
        // Validate - check that line 1 is filled for all plates
        for (let i = 0; i < state.plates.length; i++) {
            if (!state.plates[i].line1.trim()) {
                showNotification(`Please fill in Line 1 for Plate ${i + 1}`, 'error');
                setPreview(i);
                return;
            }
        }
        
        saveToHiddenField();
        
        // Add individual plate properties to form
        const form = document.querySelector('form[action*="/cart/add"]');
        if (!form) {
            showNotification('Could not find cart form', 'error');
            return;
        }
        
        // Remove old plate properties
        form.querySelectorAll('input[name^="properties[Plate"], input[name="properties[_Plates CSV]"], input[name="properties[Total Plates]"]').forEach(el => el.remove());
        
        // Add condensed plate properties (one line per plate)
        state.plates.forEach((plate, i) => {
            const num = i + 1;
            const condensed = `${plate.line1} | ${plate.line2 || '-'} | ${plate.line3 || '-'}`;
            addHiddenInput(form, `properties[Plate ${num}]`, condensed);
        });
        
        // Add total count
        addHiddenInput(form, 'properties[Total Plates]', state.plates.length);
        
        // Generate CSV data (for easy export)
        const csvLines = ['Line 1,Line 2,Line 3'];
        state.plates.forEach(plate => {
            // Escape commas and quotes in CSV
            const line1 = escapeCSV(plate.line1);
            const line2 = escapeCSV(plate.line2);
            const line3 = escapeCSV(plate.line3);
            csvLines.push(`${line1},${line2},${line3}`);
        });
        addHiddenInput(form, 'properties[_Plates CSV]', csvLines.join('\n'));
        
        // Update quantity - be aggressive about it
        const plateCount = state.plates.length;
        
        // Update ALL quantity inputs in the form
        form.querySelectorAll('input[name="quantity"]').forEach(input => {
            input.value = plateCount;
        });
        
        // Also update any quantity input on the page (outside form)
        document.querySelectorAll('input[name="quantity"], .quantity__input, [data-quantity-input]').forEach(input => {
            input.value = plateCount;
        });
        
        // Remove any existing hidden quantity we added, then add fresh one
        form.querySelectorAll('input[type="hidden"][name="quantity"][data-tp-qty]').forEach(el => el.remove());
        const hiddenQty = document.createElement('input');
        hiddenQty.type = 'hidden';
        hiddenQty.name = 'quantity';
        hiddenQty.value = plateCount;
        hiddenQty.setAttribute('data-tp-qty', 'true');
        form.appendChild(hiddenQty);
        
        console.log('Trophy Plates: Setting quantity to', plateCount);
        
        // Close modal and submit
        close();
        
        // Small delay then submit
        setTimeout(() => {
            form.submit();
        }, 100);
    }
    
    function escapeCSV(str) {
        if (!str) return '';
        // If contains comma, quote, or newline, wrap in quotes and escape quotes
        if (str.includes(',') || str.includes('"') || str.includes('\n')) {
            return '"' + str.replace(/"/g, '""') + '"';
        }
        return str;
    }

    function addHiddenInput(form, name, value) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
    }

    function saveToHiddenField() {
        const dataField = document.getElementById('tp-plates-data');
        if (dataField) {
            dataField.value = JSON.stringify({
                plates: state.plates,
                repeatLine2: state.repeatLine2,
                repeatLine3: state.repeatLine3
            });
        }
    }

    // ========== URL QUOTE LOADING ==========
    function loadQuoteFromUrl() {
        const params = new URLSearchParams(window.location.search);
        const quoteData = params.get('trophy_quote');
        
        if (!quoteData) return;
        
        try {
            const decoded = JSON.parse(decodeURIComponent(escape(atob(decodeURIComponent(quoteData)))));
            
            if (decoded.plates && decoded.plates.length > 0) {
                state.plates = decoded.plates;
                state.repeatLine2 = decoded.repeatLine2 || false;
                state.repeatLine3 = decoded.repeatLine3 || false;
                
                // Show notification
                setTimeout(() => {
                    showNotification(`Quote loaded! ${decoded.plates.length} plate${decoded.plates.length > 1 ? 's' : ''} restored.`);
                }, 500);
            }
        } catch (e) {
            console.warn('Failed to load quote from URL:', e);
        }
    }

    // ========== EMAIL QUOTE ==========
    function emailQuote() {
        const count = state.plates.length;
        
        // Build quote data for URL
        const quoteData = {
            plates: state.plates,
            repeatLine2: state.repeatLine2,
            repeatLine3: state.repeatLine3
        };
        
        const encodedData = encodeURIComponent(btoa(unescape(encodeURIComponent(JSON.stringify(quoteData)))));
        const productUrl = window.location.href.split('?')[0];
        const shareableUrl = `${productUrl}?trophy_quote=${encodedData}`;
        
        // Build email
        let body = `Hi,\n\nI'm requesting approval for the following trophy plates order:\n\n`;
        body += `Product: ${state.productTitle}\n`;
        if (state.variantTitle) body += `Variant: ${state.variantTitle}\n`;
        body += `Quantity: ${count} plate${count > 1 ? 's' : ''}\n\n`;
        body += `PLATE DETAILS:\n`;
        body += `─────────────\n`;
        
        state.plates.forEach((plate, i) => {
            body += `\nPlate ${i + 1}:\n`;
            body += `  Line 1: ${plate.line1 || '[blank]'}\n`;
            body += `  Line 2: ${plate.line2 || '[blank]'}\n`;
            body += `  Line 3: ${plate.line3 || '[blank]'}\n`;
        });
        
        body += `\n─────────────\n`;
        body += `\nClick here to review and order:\n${shareableUrl}\n\n`;
        body += `Thanks!`;
        
        const subject = `Trophy Plates Quote - ${count} Plate${count > 1 ? 's' : ''}`;
        window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        
        // Copy URL to clipboard
        navigator.clipboard.writeText(shareableUrl).catch(() => {});
        showNotification('Email opened! Link copied to clipboard.');
    }

    // ========== UTILITIES ==========
    function escapeHtml(str) {
        if (!str) return '';
        return str.replace(/[&<>"']/g, char => ({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
        })[char]);
    }

    function showNotification(message, type = 'success') {
        // Remove existing
        document.querySelectorAll('.tp-notification').forEach(n => n.remove());
        
        const notification = document.createElement('div');
        notification.className = `tp-notification ${type}`;
        notification.innerHTML = `
            <span style="font-size: 20px;">${type === 'error' ? '⚠' : '✓'}</span>
            <span>${message}</span>
        `;
        document.body.appendChild(notification);
        
        setTimeout(() => {
            notification.style.opacity = '0';
            notification.style.transform = 'translateX(100%)';
            notification.style.transition = 'all 0.3s ease';
            setTimeout(() => notification.remove(), 300);
        }, 4000);
    }

    // ========== PUBLIC API ==========
    window.trophyPlates = {
        open,
        close,
        addPlate,
        removePlate,
        updatePlate,
        setPreview,
        prevPlate,
        nextPlate,
        toggleRepeat,
        addToCart,
        emailQuote,
        getState: () => state
    };

    // Initialize when DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();